import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { ZIP_PATH, WEBSITE_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";
import { numericNormalizer } from "../../shared/normalizers";

const BIZ_PHONE_NUMBER_SPELL_NAME = "business_phone";

const FillOrigamiStepProps = {
  previous: ZIP_PATH,
  next: WEBSITE_PATH,
  question: "What's your <%= target %>",
  target: "business phone number",
  spellName: BIZ_PHONE_NUMBER_SPELL_NAME,
  placeholder: "5128675309",
  required: false,
  normalizer: numericNormalizer,
};

export const BizPhoneNumberStep: FunctionComponent<WizardProps> = (
  props: WizardProps,
) => <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />;

export default WizardContainer(BizPhoneNumberStep);
